import axios from "axios"
import router from "@/router"
// import message from "@/libs/message"
class requestModel {
  constructor(url,method,data,ignoreError,headers,onUploadProgress,responseType){
    this.url = url
    this.method = method
    this.data = data
    this.ignoreError = ignoreError || false
    this.headers = headers || {}
    this.onUploadProgress = onUploadProgress || null
    this.responseType = responseType || null
  }
}

export default async function http(options = new requestModel()){
  const service = axios.create({
    baseURL: globalConfig.baseUrl,
    timeout: globalConfig.ajaxTimeOut,
    headers:{
      'Content-Type':'application/json;charset=UTF-8',
    }
  })
  
  service.defaults.headers[globalConfig.tokenHeader] = '';

  service.defaults.headers[globalConfig.orgCodeHeader] = globalConfig.orgCode;
  service.defaults.headers[globalConfig.appIdHeader] = globalConfig.appId;
  service.defaults.headers[globalConfig.touristHeader] = globalConfig.tourist;

  service.interceptors.request.use(
    res => {
      return res
    },
    err => {
      return Promise.reject(err)
    }
  )
  
  service.interceptors.response.use(
    res => {
      if(res.status == 204 || (res.status == 200 && res.data.Success)){
        return Promise.resolve(res.data)
      }else{
        return Promise.reject(res.data)
      }
    },
    err => {
      if(err.response && err.response.data){
        if(err.response.status != 200){
          return Promise.reject(new Error(err.message))
        }
        return Promise.reject(err.response.data)
      }else{
        return Promise.reject(new Error(err.message))
      }
    }
  )

  let result = null
  try {
    if (!(options instanceof requestModel)) {
      options = new requestModel(options.url, options.method, options.data, options.ignoreError,options.headers,options.onUploadProgress,options.responseType)
    }
    let request = {
      url:options.url,
      method:options.method,
      headers:{},
      responseType:options.responseType
    }
    if (options.method.toLowerCase() === "post" && options.data instanceof FormData) {
      // 如果是 POST 请求且数据为 FormData 类型，则添加上传进度的监听器
      request.onUploadProgress = progressEvent => {
        options.onUploadProgress(progressEvent)
      }
    }

    if(options.method){
      switch(options.method.toLowerCase()){
        case "get":
          request.params = options.data
          break
        case "post":
          request.data = options.data
          break
        default:
          request.params = options.data
      }
    }else{
      request.params = options.data
    }
    
    if(options.headers){
      for(var headerKey in options.headers){
        request.headers[headerKey] = options.headers[headerKey]
      }
    }
    
    result = await service.request(request)
  } catch (error) {
		if(error instanceof Error){
			if(options.ignoreError == false){
			  // message.error(error.message)
			}
		}else{
      result = error
		  if(options.ignoreError == false){
		    // message.error(result.Msg + "：" + result.RequestNo)
		  }
      if(result.Code == 403){
        store.commit('user/loginOut')
        router.replace({name:'login'})
        return null
      }
		}
  }
  return result
}


// WEBPACK FOOTER //
// ./src/common/http.js